import Axios from "axios";
import { ApiResultModel } from "../models/common.model";
import {
  Filter,
  GetSuccessfullPaymentsRequest,
  GetSuccessfullPaymentsResponse,
} from "../models/payment.model";
import { ApiBaseUrl, PaymentUrl } from "../config/config";

export const GetSuccessfullPayments = (
  data: GetSuccessfullPaymentsRequest
): Promise<ApiResultModel<GetSuccessfullPaymentsResponse[]>> => {
  return Axios.post<ApiResultModel<GetSuccessfullPaymentsResponse[]>>(
    ApiBaseUrl + PaymentUrl + "/GetSuccessfullPayments",
    data
  ).then((result) => {
    return result.data;
  });
};

export const GetSuccessfullPaymentsExcel = async (data: Filter) => {
  return await Axios({
    method: "POST",
    url: ApiBaseUrl + PaymentUrl + "/GetSuccessfullPaymentsExcel",
    data,
    responseType: "blob",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/pdf",
    },
  }).then((response: any) => {
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `${"معوقات"} .xlsx`);
    document.body.appendChild(link);
    link.click();
  });
};
